export const isQueryParamValid = (param: undefined | null | string | string[]) => {
	return !!param && !Array.isArray(param);
};
